const ORGANIZATION_API_BASE_URL = "/organizations";

export const PLAN_API_ENDPOINTS = { GET_PLAN: (organizationId: string) => `${ORGANIZATION_API_BASE_URL}/${organizationId}/plan` } as const;
